import { render, staticRenderFns } from "./cwlgorder.vue?vue&type=template&id=da4ec4b8&"
import script from "./cwlgorder.vue?vue&type=script&lang=js&"
export * from "./cwlgorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports